module.exports = __webpack_public_path__ + "static/media/Athletico-PR.6cae894c.svg";